import axios from 'axios';
import {API_ROOT} from '../app/utils';
import {getSharingDetailsPopup} from './sharingDetailsActions';

export function findSystemGroups () {

	return function(dispatch){
		axios.get(API_ROOT + '/api/labels/system-groups',{withCredentials: true}).then( response => {

			if(response.data.state === 'SUCCEED'){

				dispatch({
					type: "FIND_SYSTEM_GROUPS",
					payload: response.data
				});

				/*
				* Fetch systemGroup and select the first one
				* */

				//if(getState().contactsGroupItemReducer.getSelectedContactsGroup === null){
					//response.data.systemGroups.forEach( systemGroupItem => {

						/*
						* If no label id on URL
						* */

						/* if(window.location.pathname === "/"){
							if(urlParam('userId')){
								if(systemGroupItem.id === '6' && systemGroupItem.ownerId === urlParam('userId')){
									dispatch(getSelectedContactsGroup({
										...systemGroupItem,
										id: systemGroupItem.id + '-' + systemGroupItem.ownerId,
										type: "system"
									}))
								}
							} else {
								if(systemGroupItem.id === '6' && systemGroupItem.ownerId === getState().profileReducer.getProfile.id){
									dispatch(getSelectedContactsGroup({
										...systemGroupItem,
										id: systemGroupItem.id + '-' + systemGroupItem.ownerId,
										type: "system"
									}))
								}
							}
						}
					});
				}*/

			} else if (response.data.state === 'RUNNING') {

				let timeOutFunc = setTimeout(() => {
					dispatch(findSystemGroups());
					clearTimeout(timeOutFunc);
				}, 5000)

			} else if (response.data.state === 'FAIL') {

				dispatch(getSharingDetailsPopup([true, 'labels_loading_error', response.data.message]));

			} else {

				dispatch(getSharingDetailsPopup([true, 'labels_loading_error', 'Unknown error']));

			}

		})
	}
}
